angular.module('public.security-manager.client.resource', ['popup.client', 'data.rate-change']);
